import React from 'react'
import GetWatchmanForm from './GetWatchmanForm'
import WatchManNav from './watchManNav'

export default function Watchman() {
  return (
    <div><WatchManNav/><GetWatchmanForm/></div>
  )
}
